var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"layout-basic",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('Header')]},proxy:true},{key:"footer",fn:function(){return [_c('Footer')]},proxy:true}])},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }